// ========================================
// AUTO-REDIRECT SCRIPT - TOIEN SIMPSON
// ========================================

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    // Pays francophones qui restent sur l'URL de base (sans /fr)
    FRENCH_COUNTRIES: ['FR', 'BE', 'CA', 'LU', 'MC'],
    
    // Pays hispanophones qui vont sur /es
    SPANISH_COUNTRIES: ['ES', 'MX', 'AR', 'CO', 'PE', 'VE', 'CL', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY', 'PR'],
    
    // Pays germanophones qui vont sur /de
    GERMAN_COUNTRIES: ['DE', 'AT', 'LI', 'CH'],
    
    // URL de base
    BASE_URL: window.location.origin,
    
    // Chemins des langues
    FRENCH_PATH: '', // Pas de redirection pour les pays francophones
    ENGLISH_PATH: '/en',
    SPANISH_PATH: '/es',
    GERMAN_PATH: '/de',
    
    // Clé de stockage pour éviter les redirections multiples
    STORAGE_KEY: 'auto_redirect_done',
    
    // API de géolocalisation (gratuite)
    GEO_API_URL: 'https://ipapi.co/json/',
    
    // Délai avant redirection (en ms) - plus long pour laisser la synchronisation de langue se faire
    REDIRECT_DELAY: 3000,
    
    // Attendre que la synchronisation de langue soit terminée
    WAIT_FOR_LANGUAGE_SYNC: true
  };

  // Fonction principale
  function initAutoRedirect() {
    // Vérifier si on a déjà fait une redirection
    if (localStorage.getItem(CONFIG.STORAGE_KEY)) {
      return;
    }

    // Vérifier si on est déjà sur une page localisée
    const currentPath = window.location.pathname;
    if (currentPath.startsWith('/fr') || currentPath.startsWith('/en') || currentPath.startsWith('/es')) {
      return;
    }

    // Attendre que la synchronisation de langue soit terminée si activée
    if (CONFIG.WAIT_FOR_LANGUAGE_SYNC) {
      waitForLanguageSync()
        .then(() => {
          // Attendre un peu plus puis vérifier si une redirection est nécessaire
          setTimeout(checkAndRedirect, 1000);
        })
        .catch(() => {
          // Si la synchronisation de langue échoue, rediriger directement
          setTimeout(checkAndRedirect, CONFIG.REDIRECT_DELAY);
        });
    } else {
      // Rediriger directement après le délai
      setTimeout(checkAndRedirect, CONFIG.REDIRECT_DELAY);
    }
  }

  // Attendre que la synchronisation de langue soit terminée
  function waitForLanguageSync() {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const maxAttempts = 30; // 3 secondes maximum
      
      const checkLanguageSync = () => {
        attempts++;
        
        // Vérifier si la synchronisation de langue est terminée
        if (localStorage.getItem('language_sync_done')) {
          resolve();
          return;
        }
        
        // Vérifier si on est maintenant sur une page localisée
        const currentPath = window.location.pathname;
        if (currentPath.startsWith('/fr') || currentPath.startsWith('/en') || currentPath.startsWith('/es')) {
          resolve();
          return;
        }
        
        if (attempts >= maxAttempts) {
          reject(new Error('Timeout waiting for language sync'));
          return;
        }
        
        setTimeout(checkLanguageSync, 100);
      };
      
      checkLanguageSync();
    });
  }

  // Vérifier et rediriger si nécessaire
  async function checkAndRedirect() {
    try {
      // Vérifier si on est déjà sur une page localisée
      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/fr') || currentPath.startsWith('/en') || currentPath.startsWith('/es')) {
        return;
      }

      // Détecter le pays de l'utilisateur
      const response = await fetch(CONFIG.GEO_API_URL, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Erreur API géolocalisation');
      }

      const data = await response.json();
      const countryCode = data.country_code;

      if (countryCode) {
        let targetPath = '';
        
        if (CONFIG.FRENCH_COUNTRIES.includes(countryCode)) {
          targetPath = CONFIG.FRENCH_PATH;
        } else if (CONFIG.SPANISH_COUNTRIES.includes(countryCode)) {
          targetPath = CONFIG.SPANISH_PATH;
        } else if (CONFIG.GERMAN_COUNTRIES.includes(countryCode)) {
          targetPath = CONFIG.GERMAN_PATH;
        } else {
          targetPath = CONFIG.ENGLISH_PATH;
        }

        if (targetPath !== undefined) {
          if (targetPath === '') {
            // Pour les pays francophones, rester sur l'URL de base
            if (currentPath.startsWith('/fr') || currentPath.startsWith('/en') || currentPath.startsWith('/es')) {
              localStorage.setItem(CONFIG.STORAGE_KEY, 'true');
              // Enlever le préfixe de langue de l'URL actuelle
              const pathWithoutLang = currentPath.replace(/^\/(fr|en|es)/, '');
              window.location.href = CONFIG.BASE_URL + pathWithoutLang;
            }
          } else if (!currentPath.startsWith(targetPath)) {
            // Pour les autres pays, rediriger vers la langue appropriée
            localStorage.setItem(CONFIG.STORAGE_KEY, 'true');
            window.location.href = CONFIG.BASE_URL + targetPath + currentPath;
          }
        }
      }
    } catch (error) {
    }
  }


  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoRedirect);
  } else {
    setTimeout(initAutoRedirect, 100);
  }


})();

